"use client";

import { MemberShipFAQ } from "@/app/components/FAQSection";
import PricingPlan from "@/app/components/PricingPlan";
import { getUserSubPlan } from "@/lib/subscription";
import { PlanCode } from "@/types/subscription";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import { useState } from "react";

interface MembershipContentProps {
  initialPlanCode: PlanCode | undefined;
}

export default function MembershipContent({ initialPlanCode }: MembershipContentProps) {
  const [userSubPlanCode, setUserSubPlanCode] = useState<PlanCode | undefined>(initialPlanCode);

  const handlePaymentComplete = async () => {
    try {
      const userPlan = await getUserSubPlan();
      setUserSubPlanCode((userPlan?.plan?.code as PlanCode) || undefined);
    } catch (error) {
      console.error("Error checking subscription status:", error);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <PricingPlan currentPlanCode={userSubPlanCode} onPaymentComplete={handlePaymentComplete} />
      <FooterTitle />
      <MemberShipFAQ />
    </>
  );
}

function FooterTitle() {
  const t = useTranslations("Membership");

  return (
    <Box
      textAlign="center"
      sx={{
        mt: { xs: 16, sm: 12 },
        pb: { xs: 20, sm: 16 },
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          top: { xs: "2.5rem", md: "3rem", lg: "4.5rem" },
          left: 0,
          right: 0,
          height: "100%",
          backgroundImage: `url(/images/member-bg-dark.png)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center 0%",
          backgroundSize: { xs: "250%", sm: "200%", md: "150%", lg: "100%" },
          zIndex: 0,
          pointerEvents: "none",
          'html[data-theme="light"] &': {
            backgroundImage: `url(/images/member-bg-light.png)`,
          },
        },
      }}>
      <Typography variant="h4" fontSize="var(--font-size-3xl)" fontWeight="600" gutterBottom>
        {t.rich("footer.title", {
          emphasize: (chunks) => (
            <Typography
              variant="h4"
              fontWeight="600"
              component="span"
              sx={{ color: "primary.main", fontSize: "var(--font-size-3xl)" }}>
              {chunks}
            </Typography>
          ),
          br: () => <br />,
        })}
      </Typography>
    </Box>
  );
}
